const GLOBAL_IMAGES = {
  Logo: require("./iTunesArtwork@x.png"),
  BANNER_IMAGE: require("./cover-pic.jpg"),
  DUMMY_COVER_IMAGE: require("./cover-pic.jpg"),
};

export { GLOBAL_IMAGES };
